import { render, staticRenderFns } from "./TraxAccountUserEditAvatarDropzone.vue?vue&type=template&id=6db8e4a1&scoped=true"
import script from "./TraxAccountUserEditAvatarDropzone.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEditAvatarDropzone.vue?vue&type=script&lang=js"
import style0 from "./TraxAccountUserEditAvatarDropzone.vue?vue&type=style&index=0&id=6db8e4a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8e4a1",
  null
  
)

export default component.exports